import React, { Component } from 'react'
import { Checkbox } from 'hljd'
import { observer } from 'mobx-react'
import style from '../style.module.less'
import { toJS } from 'mobx'

const CheckboxGroup = Checkbox.Group

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const { sendMode, changeSendMode, modeOptions } = store
    return (
      <div className={style.mode}>
        <CheckboxGroup onChange={changeSendMode} value={toJS(sendMode)}>
          {modeOptions.map((item, index) => (
            <Checkbox key={index} disabled={item.disabled} value={item.value}>
              <span className={`${style.mode_item} ${style[item.cls]}`}>
                <span
                  className={style.mode_item_bd}
                  style={{ bottom: item.disabled ? -70 : -48 }}
                >
                  <span className={style.mode_item_bd__label}>
                    {item.label}
                  </span>
                  {item.disabled && (
                    <span className={style.mode_item_bd__desc}>敬请期待</span>
                  )}
                </span>
              </span>
            </Checkbox>
          ))}
        </CheckboxGroup>
      </div>
    )
  }
}
